/**
 * Desktop thumbnail rail for the product gallery (Scuffers style).
 *
 * - Clicking a thumbnail smoothly scrolls the gallery column to that photo.
 * - The highlighted thumbnail follows the photo currently in view.
 * - The rail is re-ordered if the theme re-orders the gallery (it moves the
 *   selected variant's photo to the front when a variant is chosen).
 *
 * Desktop only (>= 990px, same breakpoint as the 3-column layout); the rail
 * is hidden by CSS below that, and nothing here runs there.
 */
(function () {
  var DESKTOP_QUERY = '(min-width: 990px)';
  var desktop = window.matchMedia(DESKTOP_QUERY);

  function setup(rail) {
    var wrapper = rail.closest('.product__media-wrapper');
    var list = wrapper && wrapper.querySelector('.product__media-list');
    if (!wrapper || !list) return;

    var railList = rail.querySelector('.product-thumb-rail__list');
    var buttons = Array.prototype.slice.call(rail.querySelectorAll('.product-thumb-rail__item'));

    function slideFor(button) {
      return list.querySelector('[data-media-id="' + button.getAttribute('data-target') + '"]');
    }

    function offsetInWrapper(el) {
      return el.getBoundingClientRect().top - wrapper.getBoundingClientRect().top + wrapper.scrollTop;
    }

    function setActive(button) {
      buttons.forEach(function (b) {
        var on = b === button;
        b.classList.toggle('is-active', on);
        if (on) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
      // Keep the active thumbnail visible inside the rail's own scroll area
      // (manual, so the gallery/page never scrolls because of it).
      if (button) {
        var item = button.parentElement;
        var top = item.offsetTop;
        var bottom = top + item.offsetHeight;
        if (top < railList.scrollTop) railList.scrollTop = top;
        else if (bottom > railList.scrollTop + railList.clientHeight) railList.scrollTop = bottom - railList.clientHeight;
      }
    }

    function updateActive() {
      var line = wrapper.getBoundingClientRect().top + wrapper.clientHeight * 0.4;
      var current = null;
      buttons.forEach(function (button) {
        var slide = slideFor(button);
        if (slide && slide.getBoundingClientRect().top <= line) current = button;
      });
      setActive(current || buttons[0]);
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var slide = slideFor(button);
        if (!slide) return;
        setActive(button);
        wrapper.scrollTo({
          top: offsetInWrapper(slide),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });
    });

    var ticking = false;
    wrapper.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        updateActive();
      });
    });

    // Follow the gallery's order when the theme moves a variant's photo first.
    function syncOrder() {
      var slides = Array.prototype.slice.call(list.children);
      var ordered = slides
        .map(function (slide) {
          return buttons.filter(function (b) {
            return b.getAttribute('data-target') === slide.getAttribute('data-media-id');
          })[0];
        })
        .filter(Boolean);
      ordered.forEach(function (b) {
        railList.appendChild(b.parentElement);
      });
      buttons = ordered.length ? ordered : buttons;
      updateActive();
    }
    new MutationObserver(syncOrder).observe(list, { childList: true });

    updateActive();
  }

  function init() {
    if (!desktop.matches) return;
    document.querySelectorAll('[data-thumb-rail]').forEach(function (rail) {
      if (rail.dataset.ready) return;
      rail.dataset.ready = 'true';
      setup(rail);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Resizing from mobile to desktop width later: set up then.
  desktop.addEventListener('change', init);
})();
